import $ from 'jquery';
import SmoothScroll from 'smoothscroll-for-websites';

export default {
    init() {
        this.smoothScroll();
    },
    smoothScroll() {


        let params = {
            animationTime: 600, // [ms]
            accelerationDelta: 10,  // 50
            accelerationMax: 1,   // 3
        };

        if (!$('body').hasClass('home')) {
            params = null
        }


        SmoothScroll(params);

    }
};



// WEBPACK FOOTER //
// ./assets/js/libs/Home.js